import { useLogto } from '@logto/react';
import { useEffect, useMemo, useState, type PropsWithChildren } from 'react';
import { NavLink } from 'react-router-dom';
import { createApiClient } from '../api/client';

export function Layout({ children }: PropsWithChildren) {
  const { getAccessToken, signOut } = useLogto();
  const api = useMemo(() => createApiClient(getAccessToken), [getAccessToken]);
  const [operator, setOperator] = useState('Operador');
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    let active = true;
    api
      .getOperators()
      .then((ops) => {
        if (active && ops[0]) setOperator(ops[0].name);
      })
      .catch(() => {
        // the sidebar name is best-effort; a failure here must not block the page
      });
    api
      .getPendingRequests()
      .then((rs) => {
        if (active) setPendingCount(rs.length);
      })
      .catch(() => {
        // the pending count is best-effort
      });
    return () => {
      active = false;
    };
  }, [api]);

  // The Pedidos page emits this after a confirm/decline so the badge updates without a reload.
  useEffect(() => {
    function onPendingChanged(e: Event) {
      const detail = (e as CustomEvent<number>).detail;
      if (typeof detail === 'number') {
        setPendingCount(detail);
      }
    }
    window.addEventListener('morabi:pending-changed', onPendingChanged);
    return () => window.removeEventListener('morabi:pending-changed', onPendingChanged);
  }, []);

  const linkClass = ({ isActive }: { isActive: boolean }) => (isActive ? 'nav-link active' : 'nav-link');

  return (
    <div className="app-shell">
      <aside className="app-sidebar">
        <div className="brand">Morabi</div>
        <div className="op-name">{operator}</div>
        <nav className="app-nav">
          <NavLink to="/" end className={linkClass}>Visão geral</NavLink>
          <NavLink to="/tours" className={linkClass}>Tours</NavLink>
          <NavLink to="/book" className={linkClass}>Reservar</NavLink>
          <NavLink to="/manifest" className={linkClass}>Manifesto</NavLink>
          <NavLink to="/requests" className={linkClass}>Pedidos{pendingCount > 0 ? ` (${pendingCount})` : ''}</NavLink>
          <NavLink to="/customers" className={linkClass}>Clientes</NavLink>
          <NavLink to="/dashboard" className={linkClass}>Receita</NavLink>
        </nav>
        <button className="btn btn-ghost signout" onClick={() => void signOut(window.location.origin)}>
          Terminar sessão
        </button>
      </aside>
      <main className="app-main">{children}</main>
    </div>
  );
}
